import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetInitiativesJiraIssuesRequest = {
	initiativeId: number;
};

export type InitiativeJiraIssue = {
	isSynced: boolean;
	issueName: string;
	issueKey: string;
	issueStatusId: string;
	projectKey: string;
};

export type GetInitiativesJiraIssuesResponse = Array<InitiativeJiraIssue>;

export const getInitiativesJiraIssues = createGetEndpoint<
	GetInitiativesJiraIssuesRequest,
	GetInitiativesJiraIssuesResponse
>(({ initiativeId }) => `/api/v3/initiatives/${initiativeId}/jira-issues`);
